import { useState, type ReactNode } from 'react';
import { Text } from '@mentimeter/ragnar-ui/text';
import {
  ModalContainer,
  ModalRoot,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from '@mentimeter/ragnar-ui/modal';
import { ThemeMentiLight } from '@mentimeter/ragnar-ui/themes';
import { Button } from '@mentimeter/ragnar-ui/button';
import { useTranslations } from 'next-intl';

const bold = (chunks: ReactNode) => <strong>{chunks}</strong>;
const italic = (chunks: ReactNode) => <em>{chunks}</em>;
const newline = () => <br />;

export function FocusNotice() {
  const [show, setShow] = useState(true);
  const translate = useTranslations('presenting.embed_integration');

  return (
    <ModalRoot open={show}>
      <ThemeMentiLight>
        <ModalContainer>
          <ModalHeader>
            {translate('powerpoint_instructions_modal_title')}
          </ModalHeader>
          <ModalBody>
            <Text mb={2}>
              {translate.rich('powerpoint_instructions_steps', {
                italic,
                bold,
                newline,
              })}
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="primary"
              onClick={() => {
                setShow(false);
              }}
            >
              {translate('understand_button')}
            </Button>
          </ModalFooter>
        </ModalContainer>
      </ThemeMentiLight>
    </ModalRoot>
  );
}
